import circlePlay from "../assets/images/circle-play.svg";
import circleBase from "../assets/images/base-yellow.svg";
import introArrow from "../assets/images/arrow-intro.svg";
import whiteSign from "../assets/images/white-sign.svg";
import lineCircle from "../assets/images/line-circle.svg";
import circleService from "../assets/images/circle-services.svg";
import purpleCircle from "../assets/images/purple-circle-service.svg";
import iconBox1 from "../assets/images/box-1.svg";
import iconBox2 from "../assets/images/box-2.svg";
import iconBox3 from "../assets/images/box-3.svg";
import star from "../assets/images/star.svg";
import blackSign from "../assets/images/black-sign.svg";
import yellowCircleArrow from "../assets/images/arrow-icon-yellow.svg";
import purpleCircleArrow from "../assets/images/arrow-icon-purple.svg";
import aboutMeLeft from "../assets/images/about-me-left.svg";
import bluePlant from "../assets/images/project-plant.svg";
import projectStar from "../assets/images/project-star.svg";
import bgSubscribe from "../assets/images/subscribe-background.svg";
import earth from "../assets/images/earth.svg";
import subscribeArrow from "../assets/images/subscribe-arrow.svg";
import real from "../assets/images/real.svg";
import abstract from "../assets/images/abstract.svg";
import coderBackground from "../assets/images/coder-background.svg";
import project1 from "../assets/images/project1.png";
import project3 from "../assets/images/project3.png";
import project4 from "../assets/images/project4.png";
import figmaWhite from "../assets/images/figmaWhite.svg";
import figmaPurple from "../assets/images/figmaPurple.svg";
import bgProject from "../assets/images/bg-project.svg";
import calendarIcon from "../assets/images/icon-calendar.svg";
import famfundVisual1 from "../assets/images/project-visual-famfund1.svg";
import famfundVisual2 from "../assets/images/project-visual-famfund2.svg";
import githubYellow from "../assets/images/github-yellow.svg";
import githubWhite from "../assets/images/github-white.svg";
import figmaFill from "../assets/images/figma-fill.svg";
import gmailDefault from "../assets/images/gmail-default.svg";
import gmailHeader from "../assets/images/gmail-header.svg";
import linkedinFill from "../assets/images/linkedin-fill.svg";
import linkedinColor from "../assets/images/linkedin-color.svg";
import figmaColor from "../assets/images/figma-header.svg";
import githubColor from "../assets/images/github-header.svg";
import githubFill from "../assets/images/github-fill.svg";
import figmaCircle from "../assets/images/figma-circle.svg";
import linkedinCircle from "../assets/images/linkedin-circle.svg";
import githubCircle from "../assets/images/github-circle.svg";
import gmailCircle from "../assets/images/gmail-circle.svg";
import aboutIMG1 from "../assets/images/about-img1.svg";
import aboutIMG2 from "../assets/images/about-img2.svg";
import aboutIMG3 from "../assets/images/about-img3.svg";
import aboutIMG4 from "../assets/images/about-img4.svg";
import aboutIMG5 from "../assets/images/about-img5.svg";
import aboutIMG6 from "../assets/images/about-img6.svg";
import aboutDecorFirstBlock from "../assets/images/about-decor-first-block.svg";
import randomFact from "../assets/images/random-fact-image.png";
import myStory from "../assets/images/my-story-image.svg";
import prohireVisual1 from "../assets/images/prohire1.svg";
import prohireVisual2 from "../assets/images/prohire2.svg";
import tripmateVisual1 from "../assets/images/tripmate1.svg";
import tripmateVisual2 from "../assets/images/tripmate2.svg";
import portfolioVisual1 from "../assets/images/portfolio1.svg";
import portfolioVisual2 from "../assets/images/portfolio2.svg";
import project5 from "../assets/images/project5.png";
import project2 from "../assets/images/project2.png";

const images = {
  circlePlay,
  circleBase,
  introArrow,
  whiteSign,
  lineCircle,
  circleService,
  purpleCircle,
  iconBox1,
  iconBox2,
  iconBox3,
  star,
  blackSign,
  yellowCircleArrow,
  purpleCircleArrow,
  aboutMeLeft,
  bluePlant,
  projectStar,
  bgSubscribe,
  earth,
  subscribeArrow,
  real,
  abstract,
  coderBackground,
  project1,
  project3,
  project4,
  figmaWhite,
  figmaPurple,
  bgProject,
  calendarIcon,
  famfundVisual1,
  famfundVisual2,
  githubYellow,
  githubWhite,
  figmaFill,
  gmailDefault,
  gmailHeader,
  linkedinFill,
  linkedinColor,
  figmaColor,
  githubColor,
  githubFill,
  figmaCircle,
  linkedinCircle,
  githubCircle,
  gmailCircle,
  aboutIMG1,
  aboutIMG2,
  aboutIMG3,
  aboutIMG4,
  aboutIMG5,
  aboutIMG6,
  aboutDecorFirstBlock,
  randomFact,
  myStory,
  prohireVisual1,
  prohireVisual2,
  tripmateVisual1,
  tripmateVisual2,
  portfolioVisual1,
  portfolioVisual2,
  project5,
  project2,
};

export default images;
